import React from 'react';
import PropTypes from 'prop-types';

import { determineFontColor } from 'lib/colorLogic';
import overrideStyle from 'lib/overrideStyle';
import getRadius from 'lib/getRadius';
import { Communicators } from 'presentation/components/lib/communicators';

export default function FileMessageItem(props) {
  return (
    <FileItem alt={props.altText || `${props.sender} image`} data-aid="gladlyFileMessageItem" sender={props.sender}>
      {props.fileName}
    </FileItem>
  );
}

FileMessageItem.propTypes = {
  altText: PropTypes.string,
  fileName: PropTypes.string.isRequired,
  sender: PropTypes.string.isRequired,
};

const FileItem = overrideStyle('div')`
  align-self: ${p => (p.sender === Communicators.CUSTOMER ? 'flex-end' : 'flex-start')};
  background-color: ${p => p.theme.colors.attachmentBackground};
  border-radius: ${p => getRadius(p.theme.borderRadius, 8, 16)};
  color: ${p => determineFontColor(p.theme.colors.attachmentBackground)};
  font-size: 13px;
  flex: 0 0 auto;
  height: 140px;
  max-width: 250px;
  margin: 15px;
  object-fit: cover;
  padding: 10px;
  width: 240px;
  word-wrap: break-word;
`;
